module.exports = __webpack_public_path__ + "static/media/insta-12.af119668.png";